<template>
  <div class="row">
    <div class="col d-flex justify-content-around">
      <div class="p-2 text-center">
        <h1>Biriweb</h1>
        <h3>Em breve</h3>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'IndexPage'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IndexPage.vue